var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Change Email Address"),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            { attrs: { "for-id": "email", error: _vm.$showError("email") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("New Email Address"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.emailAddress,
                    expression: "data.emailAddress",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, email: true, max: 255 },
                    expression: "{required: true, email: true, max: 255}",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "email",
                  type: "email",
                  name: "email",
                  autofocus: "",
                  "data-vv-as": "Email Address",
                },
                domProps: { value: _vm.data.emailAddress },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "emailAddress", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "rb-input",
            {
              attrs: {
                "for-id": "confirmEmail",
                error: _vm.$showError("confirmEmail"),
              },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Confirm New Email Address"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.confirmEmailAddress,
                    expression: "data.confirmEmailAddress",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, value: _vm.data.emailAddress },
                    expression: "{ required: true, value: data.emailAddress }",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "confirmEmail",
                  type: "email",
                  name: "confirmEmail",
                  "data-vv-as": "Confirm Email Address",
                },
                domProps: { value: _vm.data.confirmEmailAddress },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.data,
                      "confirmEmailAddress",
                      $event.target.value
                    )
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }